import { Button } from '@/components/shadcn/button'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconReturnOutline } from '@icons/IconReturnOutline'
import { IconTransformOutline } from '@icons/IconTransformOutline'
import { Suspense, useState } from 'react'
import { ActivityLogV2Props } from '../ActivityLogV2'
import { NextStepHeading } from './NextStepHeading'
import { ReturnFileComponent } from './ReturnFileComponent'
import { usePostTransitionUpdate } from './usePostTransitionUpdate'
import { IconV2ArrowLeftOutline } from '@icons/IconV2ArrowLeftOutline'

type LogItem = RestSchemas['Messages.Templates.TTemplateActivity']

export function CompletedAction({
  entityId,
  templateId,
  lastActivity,
}: ActivityLogV2Props & { lastActivity: LogItem }) {
  return (
    <>
      <NextStepHeading>Acceptance process is completed</NextStepHeading>
      <Suspense fallback={<div>Loading...</div>}>
        <CompletedActionContents entityId={entityId} templateId={templateId} lastActivity={lastActivity} />
      </Suspense>
    </>
  )
}

function CompletedActionContents({
  entityId,
  templateId,
  lastActivity,
}: ActivityLogV2Props & { lastActivity: LogItem }) {
  const [returnClicked, setReturnClicked] = useState(false)
  const { isPending } = usePostTransitionUpdate({ entityId, templateId })

  const onCancel = () => {
    setReturnClicked(false)
  }

  if (isPending) {
    return (
      <div className="flex w-full items-center justify-center gap-x-2 py-6">
        <IconTransformOutline className="size-6 animate-spin text-primary" />
        <p className="text-sm">Uploading...</p>
      </div>
    )
  }

  if (returnClicked) {
    return <ReturnFileComponent entityId={entityId} templateId={templateId} onCancel={onCancel} />
  }
  return (
    <div>
      <Button
        disabled={!lastActivity.file_template.allow_return}
        variant="outline"
        className="h-7"
        size="sm"
        onClick={() => setReturnClicked(true)}
      >
        <IconV2ArrowLeftOutline className="mr-1 size-3" />
        Return file?
      </Button>
    </div>
  )
}
